/* eslint-disable react/no-multi-comp */
import React, { useEffect, useState } from 'react'

// StrikethroughButton
const StrikethroughButton = (props) => {

  // let _onClick = props.onOverrideContent(HeadlinesPicker);
  let _onClick = () => {
    console.log("StrikethroughButton._onClick")
    props.sampleButtonClicked()
  }

  let _onMouseDown = (event) => event.preventDefault();

  return (
    <div onMouseDown={_onMouseDown} className="headlineButtonWrapper">
      <button onClick={_onClick} className="headlineButton" style={{
        textDecoration: 'line-through',
      }}>
        H
      </button>
    </div>
  )
}
export default StrikethroughButton
